import { Component, inject, input, output } from '@angular/core';

import { SiteWorkflowDirective } from '@features/feature-workflow/directives/site-workflow.directive';

import { ButtonComponent } from '@shared/components/button/button.component';
import {
  AuxButtonGroup,
  ButtonGroupComponent,
} from '@shared/components/button-group/button-group.component';
import { ErrorsTooltipComponent } from '@shared/components/errors-tooltip/errors-tooltip.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { OverlayService } from '@shared/services/overlay.service';

import { SiteBudgetGridComponent } from '../site-budget-grid/site-budget-grid.component';

@Component({
  hostDirectives: [SiteWorkflowDirective],
  imports: [ButtonComponent, ButtonGroupComponent, TooltipDirective, ErrorsTooltipComponent],
  selector: 'aux-site-budget-table-buttons',
  standalone: true,
  templateUrl: './site-budget-table-buttons.component.html',
})
export class SiteBudgetTableButtonsComponent {
  overlayService = inject(OverlayService);
  siteWorkflow = inject(SiteWorkflowDirective);

  disabled = input(false);
  editMode = input.required<boolean>();
  isDataProcessing = input(false);
  isSiteInvoiceables = input(false);
  siteBudgetGridComponent = input.required<SiteBudgetGridComponent>();

  cancelChanges = output<void>();
  edit = output<void>();
  removeRows = output<void>();
  saveChanges = output<void>();

  readonly addNewRowsOptions: AuxButtonGroup[] = [
    {
      name: 'Add row',
      onClick: () => {
        this.siteBudgetGridComponent().addRows(1);
      },
    },
    {
      name: 'Add 5 Rows',
      onClick: () => {
        this.siteBudgetGridComponent().addRows(5);
      },
    },
    {
      name: 'Add 10 Rows',
      onClick: () => {
        this.siteBudgetGridComponent().addRows(10);
      },
    },
    {
      name: 'Add 20 Rows',
      onClick: () => {
        this.siteBudgetGridComponent().addRows(20);
      },
    },
  ];

  async onDeleteRows() {
    await this.siteBudgetGridComponent().removeSelectedRows(() => this.removeRows.emit());
  }
}
